import type { HexColor } from "../hex-color/hex-color";
import type { HSL } from "../hsla-color/hsl-color";
import type { HSLA } from "../hsla-color/hsla-color";
import type { RGB } from "../rgba-color/rgb-color";
import type { RGBA } from "../rgba-color/rgba-color";
import { hexToRgba } from "./hex-to-rgba";
import { hslaToRgba } from "./hsla-to-rgba";

const toRgba = (color: HexColor | HSL | HSLA | RGB | RGBA): RGB | RGBA => {
    if (typeof color === "string") return hexToRgba(color);
    if ("red" in color)
        return {
            ...color,
            alpha: "alpha" in color ? color.alpha : 1,
        };
    if ("hue" in color) {
        return hslaToRgba(
            color.hue,
            color.light,
            color.saturation,
            "alpha" in color ? color.alpha : 1,
        );
    }
    throw new Error("Unhandled color type; " + JSON.stringify(color));
};

export { toRgba };
